import { HTTPClient } from '../utils/request'

export default {
  recover: ({ payload }) =>
    HTTPClient.post(
      `/forgot_password`, payload
    )
}
